import { render, staticRenderFns } from "./base-line.vue?vue&type=template&id=b133f352&scoped=true"
import script from "./base-line.vue?vue&type=script&lang=js"
export * from "./base-line.vue?vue&type=script&lang=js"
import style0 from "./base-line.vue?vue&type=style&index=0&id=b133f352&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b133f352",
  null
  
)

export default component.exports